const MobileAppColorIcon = ({ color = "#212121" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="18"
      viewBox="0 0 15 18"
      fill="none"
    >
      <path
        d="M13.75 4.75V12.75C13.75 15.95 12.9375 16.75 9.6875 16.75H4.8125C1.5625 16.75 0.75 15.95 0.75 12.75V4.75C0.75 1.55 1.5625 0.75 4.8125 0.75H9.6875C12.9375 0.75 13.75 1.55 13.75 4.75Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.875 3.55078H5.625"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.2501 14.4292C7.94563 14.4292 8.50947 13.8741 8.50947 13.1892C8.50947 12.5044 7.94563 11.9492 7.2501 11.9492C6.55456 11.9492 5.99072 12.5044 5.99072 13.1892C5.99072 13.8741 6.55456 14.4292 7.2501 14.4292Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default MobileAppColorIcon;
